import { decodeToken } from '../Services/Users.service';

const GLOBAL_ADMIN_CLAIM_KEYS = ['GlobalAdmin', 'globalAdmin', 'global_admin'];
const TRUTHY_STRING_VALUES = ['y', 'yes', 'true', '1'];

const normalizeGlobalAdminValue = (value: unknown): boolean => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
        return TRUTHY_STRING_VALUES.includes(value.trim().toLowerCase());
    }
    return false;
};

/**
 * Determines whether the currently logged-in user is a global admin.
 * Reads the `GlobalAdmin` claim from the decoded access token (JWT), which the
 * API embeds after GetAccessToken/RefreshAccessToken (as "Y"/"N" or boolean).
 */
export const isGlobalAdminUser = (): boolean => {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) return false;

    try {
        const decoded = decodeToken(accessToken) as Record<string, unknown> | null;
        if (!decoded) return false;

        const claimValue = GLOBAL_ADMIN_CLAIM_KEYS
            .map(key => decoded[key])
            .find(value => value !== undefined);

        return normalizeGlobalAdminValue(claimValue);
    } catch {
        return false;
    }
};
